export default class HookError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'HookError';
  }
}
